export const textingKeys = {
  setup: (locationId: string) => ['texting', 'setup', locationId] as const,
  numbers: (locationId: string, areaCode: string) =>
    ['texting', 'numbers', locationId, areaCode] as const,
  registrationPrefill: (locationId: string) =>
    ['texting', 'registrationPrefill', locationId] as const,
};
